import { useEffect, useState } from 'react';

// El mismo umbral que usa el CSS (`@media (max-width: 767px)`) y el que decide
// el modo inicial del aparato. Vive aquí para que el JSX que cambia de
// componente —lista en vez de rejilla, hoja en vez de panel— use exactamente
// la misma frontera que las hojas de estilo y no haya un ancho en el que el
// marcado sea de teléfono y el CSS de tablet.
export const ANCHO_TELEFONO = 768;
const QUERY = `(max-width: ${ANCHO_TELEFONO - 1}px)`;

export const esTelefono = () =>
  typeof window !== 'undefined' && window.matchMedia(QUERY).matches;

export function useEsTelefono() {
  const [es, setEs] = useState(esTelefono);
  useEffect(() => {
    const mq = window.matchMedia(QUERY);
    const onChange = (e) => setEs(e.matches);
    mq.addEventListener('change', onChange);
    setEs(mq.matches);
    return () => mq.removeEventListener('change', onChange);
  }, []);
  return es;
}
